import React from 'react';
import { ROUTES } from './constants';
import { Route } from 'circe/routing/provider';
import { AUTHORITIES } from 'domain/fuse/auth/constants';

import RequireAuth from 'circe/authorization/components/AuthorizationRoute';
import { loadComponent } from 'domain/layout/utils';

/* istanbul ignore next */
const container = loadComponent(() => import('./components/Query'));

const authorizedContainer = RequireAuth(
  container,
  [AUTHORITIES.VISITOR, AUTHORITIES.AUTHENTICATED, AUTHORITIES.ACCOUNT_ADMIN, AUTHORITIES.OPERATOR],
  '/',
);

const Routes = () => {
  return <Route exact path={ROUTES.ROOT} key={ROUTES.ROOT} component={authorizedContainer} />;
};

export default Routes;
